import React, { useState } from 'react';
import { Building2 } from 'lucide-react';
import { HostingApplicationModal } from './HostingApplicationModal';
import type { ExchangeRates } from '../../utils/currencyUtils';

interface ApplyHostingButtonProps {
  facility: any;
  currency: string;
  exchangeRates: ExchangeRates;
}

export function ApplyHostingButton({ facility, currency, exchangeRates }: ApplyHostingButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
      >
        <Building2 className="w-5 h-5" />
        <span className="font-medium">Apply for Hosting</span>
      </button>

      <HostingApplicationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        facility={facility}
        currency={currency}
        exchangeRates={exchangeRates}
      />
    </>
  );
}